if($('body.desktop.type-manufacturer-detail').length){
  $(document).ready(function(){
    mhManufactured();
  });
    document.addEventListener('ShoptetDOMPageContentLoaded', function() {
        mhManufactured();
    });


}

function mhManufactured(){
    $('.content-wrapper-in').addClass('sidebar-indented')
  const $content = $('#content');
  const $start = $('.category-title');
  const $end = $('#filters-wrapper');
  const $categoryTop = $('<div class="category-top"></div>');
  const $sidebar = $('<aside class="sidebar sidebar-left"></aside>');
  const $categoryContent = $('<div class="category-content-wrapper"></div>');
  const $elementsToMove = $start.nextUntil($end).addBack().add($end);
  $categoryTop.append($elementsToMove);
  const $filtersInner = $categoryTop.find('.filters-wrapper');
  $sidebar.append($filtersInner);
  $content.children().not($categoryTop).each(function () {
    $categoryContent.append($(this));
  });
  $content.empty().append($categoryTop, $sidebar, $categoryContent);
}